/**
 * Handler: server-side page_view on SPA navigation
 */

import type { WindowAnalyzify } from '../../types/window-analyzify';
import { generateEventId } from '../utils';

export function handlePageView(analyzify: WindowAnalyzify): void {
  if (typeof analyzify.ssPageView === 'function') {
    // Reuse the page's 'default' event ID — the same ID the sh_info push for
    // this page carries — so the browser and server page_view can be deduped.
    const eventId = analyzify.eventId?.get?.('default') || generateEventId();
    analyzify.ssPageView(eventId);
  }
}
